export const useStyles = theme => ({
  root: {
    flexGrow: 1
    //   height: 250,
  },
  container: {
    flexGrow: 1,
    position: "relative"
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  inputRoot: {
    flexWrap: "wrap"
  },
  inputInput: {
    width: "auto",
    flexGrow: 1
  },
  divider: {
    height: theme.spacing(2)
  },
  rootChip: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    minWidth: 160,
    marginRight: 4
  },
  inputChip: {
    marginLeft: 8,
    flex: 1,
    width: 50
  },
  iconButtonChip: {
    padding: 10
  },
  dividerChip: {
    width: 1,
    height: 28,
    margin: 4
  }
});
